
$(document).ready(function () {

  $('.custom-product-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    dots: false,

    responsive: [
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
         {
        breakpoint: 481,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $('.custom-slider-prev').click(function () {
    $('.custom-product-slider').slick('slickPrev');
  });

  $('.custom-slider-next').click(function () {
    $('.custom-product-slider').slick('slickNext');
  });

});

$(document).ready(function () {

  $('.testimonial-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    dots: false,
    adaptiveHeight: false,

    responsive: [
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

});


document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.videos-section .media-item').forEach(function (item) {

    const thumbnail = item.querySelector('.video-thumbnail');
    const video = item.querySelector('.video-player');
    const playButton = item.querySelector('.play-btn');

    if (!thumbnail || !video || !playButton) return;

    playButton.addEventListener('click', function (event) {

      event.preventDefault();
      event.stopPropagation();

      thumbnail.style.display = 'none';
      video.style.display = 'block';

      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.catch(function (error) {
          console.log('Video play failed:', error);
        });
      }

    });

  });

});



//js for the read more on the product page description
document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('product-component .product__description').forEach(function (wrapper) {
    const text = wrapper.querySelector('.description-text');
    const button = wrapper.querySelector('.read-more-btn');

    if (!text || !button) return;

    const styles = window.getComputedStyle(text);
    const lineHeight = parseFloat(styles.lineHeight);

    // 2 lines ki maximum height
    const maxHeight = lineHeight * 2;

    text.style.maxHeight = maxHeight + 'px';
    text.style.overflow = 'hidden';

    button.addEventListener('click', function () {
      text.classList.toggle('expanded');

      if (text.classList.contains('expanded')) {
        text.style.maxHeight = text.scrollHeight + 'px';
        button.textContent = 'Read Less';
      } else {
        text.style.maxHeight = maxHeight + 'px';
        button.textContent = 'Read More';
      }
    });
  });
});

// document.querySelectorAll('.product-form__input.product-form__input--dropdown .custom-select__trigger').forEach(select__trigger => {
//        select__trigger.addEventListener('click', function () {
//         console.log('Trigger clicked');
//          const ul = this.closest('.product-form__input--dropdown').querySelector('ul');

//         if (ul) {
//             ul.style.display = ul.style.display === 'block' ? 'none' : 'block';
//         }
//       });
      
// }); 
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('details').forEach((details) => {
    const content = details.querySelector('.accordion__content');
    const summary = details.querySelector('summary');

    if (!content || !summary) return; // agar element missing hai to is details ko skip karo

    details.setAttribute('open', '');
    if (!details.classList.contains('is-open')) {
      content.style.maxHeight = '0px';
    }

    summary.addEventListener('click', (e) => {
      e.preventDefault();

      const isOpen = details.classList.contains('is-open');

      if (isOpen) {
        content.style.maxHeight = content.scrollHeight + 'px';
        requestAnimationFrame(() => {
          content.style.maxHeight = '0px';
        });
        details.classList.remove('is-open');
      } else {
        details.classList.add('is-open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
});